const StationChecklistActionTypes = {
  FETCH_STATION_CHECKLIST_START: 'FETCH_STATION_CHECKLIST_START',
  FETCH_STATION_CHECKLIST_SUCCESS: 'FETCH_STATION_CHECKLIST_SUCCESS',
  FETCH_STATION_CHECKLIST_FAILURE: 'FETCH_STATION_CHECKLIST_FAILURE',
  SET_SELECTED_STATION_CHECKLIST: 'SET_SELECTED_STATION_CHECKLIST',

  SET_STATION_CHECKLIST_LOADING: 'SET_STATION_CHECKLIST_LOADING',
};

export default StationChecklistActionTypes;
